<div class="panel-body">
    <div class="card">
        <ng-container *ngIf="hasProducts">
            <div class="card-header hidden-mobile">
                <span class="pull-left" translate="cart.order.history.product"></span>
                <span *ngFor="let label of headerLabels; trackBy: trackByFn" translate="{{ label }}"></span>
            </div>
            <order-history-product (itemAdded)="itemAdded.emit($event)" *ngFor="let viewProduct of orderView.products; trackBy: trackByFn"
                                   [viewProduct]="viewProduct" [displayAttributes]="displayAttributes" [currencyCode]="orderView.currencyCode" [orderId]="orderView.id"></order-history-product>
        </ng-container>
        <ng-container *ngIf="!hasProducts">
            <div class="card-body">
                <span class="pull-left" translate="cart.order.history.no.products"></span>
            </div>
        </ng-container>
    </div>
</div>

